import InviteMemberModal from './InviteMemberModal.component';

export default InviteMemberModal;
